<template>
  <section v-if="cards.length" class="totem-products" aria-label="Produtos">
    <h3>Conheça também nossa Loja</h3>
    <p class="totem-products__subtitle">
      Aponte a câmera do celular para ver o produto.
    </p>

    <div class="totem-products__grid">
      <article v-for="card in cards" :key="card.id" class="totem-product">
        <div class="totem-product__media">
          <img
            v-if="card.imageUrl && !imageErrors[card.id]"
            :src="card.imageUrl"
            :alt="card.name"
            loading="eager"
            @error="markImageError(card.id)"
          />
          <v-icon v-else color="#a3a8bd" size="54">mdi-shopping-outline</v-icon>
        </div>
        <div class="totem-product__details">
          <strong>{{ card.name }}</strong>
          <span>A partir de {{ formatPrice(card.priceFromCents) }}</span>
        </div>
        <img
          class="totem-product__qr"
          :src="card.qrCode"
          :alt="`QR Code para abrir ${card.name} no celular`"
        />
      </article>
    </div>
  </section>
</template>

<script>
import QRCode from "qrcode";
import {
  fetchTotemProducts,
  getCachedTotemProducts,
  productDeepLink,
} from "@/service/totemProducts";

export default {
  name: "TotemProductShowcase",
  data() {
    return {
      cards: [],
      imageErrors: {},
      loadGeneration: 0,
      destroyed: false,
    };
  },
  mounted() {
    this.loadProducts();
  },
  beforeDestroy() {
    this.destroyed = true;
    this.loadGeneration += 1;
  },
  methods: {
    async loadProducts() {
      const generation = ++this.loadGeneration;
      const cached = getCachedTotemProducts();
      if (cached.length) await this.setCards(cached, generation);

      const products = await fetchTotemProducts();
      if (this.destroyed || generation !== this.loadGeneration) return;
      await this.setCards(products, generation);
    },
    async setCards(products, generation) {
      const cards = await Promise.all(
        products.slice(0, 3).map(async (product) => {
          const deepLink = productDeepLink(product);
          if (!deepLink) return null;
          try {
            const qrCode = await QRCode.toDataURL(deepLink, {
              errorCorrectionLevel: "M",
              margin: 1,
              width: 180,
            });
            return { ...product, deepLink, qrCode };
          } catch (_error) {
            return null;
          }
        })
      );
      if (this.destroyed || generation !== this.loadGeneration) return;
      this.cards = cards.filter(Boolean);
    },
    markImageError(id) {
      this.imageErrors = { ...this.imageErrors, [id]: true };
    },
    formatPrice(priceFromCents) {
      return (priceFromCents / 100).toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL",
      });
    },
  },
};
</script>

<style scoped>
.totem-products {
  margin-top: 22px;
  width: 100%;
}

.totem-products h3 {
  color: #354270;
  font-size: 28px;
  line-height: 1.1;
  margin: 0;
  text-align: center;
}

.totem-products__subtitle {
  color: #656d8e;
  font-size: 17px;
  margin: 6px 0 14px;
  text-align: center;
}

.totem-products__grid {
  display: grid;
  gap: 12px;
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.totem-product {
  align-items: center;
  background: #f8f8fc;
  border: 1px solid #ebeaf2;
  border-radius: 18px;
  display: grid;
  gap: 10px;
  grid-template-columns: 76px minmax(0, 1fr) 86px;
  min-width: 0;
  padding: 10px;
}

.totem-product__media {
  align-items: center;
  background: #fff;
  border-radius: 13px;
  display: flex;
  height: 76px;
  justify-content: center;
  overflow: hidden;
  width: 76px;
}

.totem-product__media img {
  height: 100%;
  object-fit: cover;
  width: 100%;
}

.totem-product__details {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.totem-product__details strong {
  color: #313b67;
  display: -webkit-box;
  font-size: 16px;
  line-height: 1.2;
  overflow: hidden;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.totem-product__details span {
  color: #ff006b;
  font-size: 15px;
  font-weight: 700;
  margin-top: 6px;
}

.totem-product__qr {
  background: #fff;
  border-radius: 10px;
  height: 86px;
  padding: 4px;
  width: 86px;
}

@media (max-width: 900px) {
  .totem-products__grid {
    grid-template-columns: 1fr;
  }
}
</style>
